import * as z from 'zod';

import { StopSettings } from '../loan/StopSettings';
import { BaseLoanEvent } from './BaseLoanEvent';

export const FlagAccountEvent = BaseLoanEvent.extend({
  type: z.literal('flagAccount'),
  isFlagged: z.boolean(),
  /**
   * @deprecated use the {@link UpdateStopSettingsEvent} instead.
   * Kept to maintain existing audit logs.
   */
  stopSettings: StopSettings.optional(),
  comment: z.string().optional(),
});
export type FlagAccountEvent = z.infer<typeof FlagAccountEvent>;
